const CustomTheme =  {
    fonts: {
        primary: "PT Serif, Mulish, Helvetica,sans-serif",
        secondary: "Roboto Mono, monospace, Fira code",
    },
    colors: {
        primary1: "hsl(184, 91%, 17%)",
        primary2: "hsl(185, 84%, 25%)",
        primary3: "hsl(185, 81%, 29%)",
        primary4: "hsl(184, 77%, 34%)",
        primary5: "#2caeba",
        primary6: "hsl(185, 57%, 50%)",
        primary7: "hsl(184, 65%, 59%)",
        primary8: "hsl(184, 80%, 74%)",
        primary9: "hsl(185, 94%, 87%)",
        primary10: "hsl(199, 56%, 81%, 1)",
        grey1: "hsl(209, 61%, 16%)",
        grey3: "hsl(209, 34%, 30%)",
        grey4: "hsl(209, 28%, 39%)",
        grey5: "hsl(210, 22%, 49%)",
        grey8: "hsl(210, 31%, 80%)",
        grey9: "hsl(212, 33%, 89%)",
        grey10: "hsl(210, 36%, 96%)",
        greenDark: "hsl(125, 67%, 35%)",
        redDark: "hsl(360, 67%, 44%)",
        redLight: "hsl(360, 71%, 66%)",
        white: "hsl(0, 0%, 100%)",
        black: "hsl(0, 0%, 0%)",
    },
    breakpoints: {
        desktop: "only screen and (min-width: 64rem)",
        mobile: "only screen and (min-width: 37rem)",
    },
    spacings: {
        xxSmall: "0.2rem",
    },
    animations: {
        transition: "all 0.3s linear",
    },
    shadows: {
        lightShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
        darkShadow: "0 5px 15px rgba(0, 0, 0, 0.2)",
    },
    radius: {
        small: "0.25rem",
    },
    sizes: {
        xxSmall: ".4rem",
        xSmall: "0.875rem",
        small: "2rem",
        medium: "3.3rem",
        large: "4.8rem",
        xLarge: "6.4rem",
        xxLarge: "9.6rem",
        default: "1.36rem"
    },
    weights: {
        normal: "normal",
        bold: "bold",
        lighter: "lighter",
        bolder: "bolder",
        large: "400",
        xLarge: "700",
        xxLarge: "900",
    },
    heights: {
        normal: "normal",
        height1: "1.5",
        height2: "2.7rem",
        height3: "4rem",
        height4: "4.8rem",
        height5: "0.4rem",
        height6: "5.7rem",
    },
    widths: {
        medium: "8rem",
        maxWidth: "1170px",
        fixedWidth: "70rem",
    }
}

export default CustomTheme